import { withPlatformImageAssetLoader } from '@mews-distributor/common';
import { CardTypeList as BaseCardTypeList } from '@mews/business-components';

import { inject } from './inject';

// @ts-expect-error $TSFixMeError: Argument of type 'ComponentType<CardTypeListProps>' is not assignable to parameter of type 'ComponentType<Matching<{ sup...
export const CardTypeList = inject(withPlatformImageAssetLoader(BaseCardTypeList));
